import styled, { css } from 'styled-components';
import List from 'components/List/styles';
import CheckBoxStyles from 'components/Checkbox/styles';
import Tokens from '@nokia-csf-uxr/freeform-design-tokens';
import { DEEP_BORDER_BOX } from 'common';

const {
  SPACING,
  FONT_FAMILY,
  LINE_HEIGHT,
} = Tokens;
const SPACING_2 = '0.125rem';
const SPACING_10 = '0.625rem';
const SPACING_FOR_2_LINES = '3.75rem';

const MultiSelectSmartListWrapper = styled.div`
  ${DEEP_BORDER_BOX}
  ${props => css`direction: ${(props.RTL || props.$rtl || props.rtl) ? 'rtl' : 'ltr'};`}
  cursor: pointer;
  outline: none;
  ${List.ListItemText} {
    line-height: ${LINE_HEIGHT.LINE_HEIGHT_NORMAL}
  }
`;
const SmartListTitle = styled.div`
  font-family: ${FONT_FAMILY.NOKIA_PURE_TEXT};
  border-bottom: 0.0625rem solid${({ $theme }) => $theme.divider};
  border-top: 0.0625rem solid ${({ $theme }) => $theme.divider};
  height: ${SPACING.SPACING_48};
  color: ${({ $theme }) => $theme && $theme.groupHeading};
  background-color: ${({ $theme }) => $theme.headerBackground};
  display: flex;
  align-items: center;
`;
const SmartListItem = styled(List.ListItemBasic)`
  padding: ${SPACING.SPACING_12} ${SPACING_2};
  ${props => css`height: ${props.hasSecondaryLabel ? `${SPACING_FOR_2_LINES}` : `${SPACING.SPACING_48}`};`}
  align-items: flex-start;
  &:focus, &:focus-within {
    padding: ${SPACING_10} 0;
  }
  &:hover {
    cursor: pointer;
  }
  ${({ disabled }) => disabled && css`
    color: ${({ $theme }) => $theme && $theme.disabled && $theme.disabled.text};
  `};
`;
const SmartListItemTextWrapper = styled.span`
  display: flex;
  flex-direction: column;
  padding: ${SPACING_2} 0;
`;
const SmartListItemCheckbox = styled.div`
  height: 20px;
  ${props => css`padding: ${props.rtl ? '0 0.875rem 0 0.25rem' : '0 0.25rem 0 0.875rem'};`}
  margin-top: 0.125rem;
  ${CheckBoxStyles.Wrapper} {
    ${props => css`margin: ${props.rtl ? '0 0 0 0.75rem' : '0 0.75rem 0 0'};`}
  }
  ${({ disabled }) => disabled && css`
  svg {
    & * {
      fill: ${({ $theme }) => $theme.disabled.icon};
    }
  `};
`;
const SmartListItemIconWrapper = styled.div`
  ${props => css`right: ${(props.RTL || props.$rtl || props.rtl) ? 'unset' : '2px'};`};
  ${props => css`left: ${(props.RTL || props.$rtl || props.rtl) ? '2px' : 'unset'};`};
  position: sticky;
  height: 1.5rem;
  display: flex;
  align-items: center;
  svg {
    & * {
      fill: ${({ $theme }) => $theme.icon};
    }
  }
  ${({ disabled }) => disabled && css`
    svg {
      & * {
        fill: ${({ $theme }) => $theme.disabled.icon};
      }
     `};
`;
const styles = {
  MultiSelectSmartListWrapper,
  SmartListTitle,
  SmartListItem,
  SmartListItemTextWrapper,
  SmartListItemCheckbox,
  SmartListItemIconWrapper,
};

export default styles;